module.exports = __webpack_public_path__ + "img/Gruppenführer_N.b8513c50.svg";